(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-split"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const items = Array.from(document.querySelectorAll('.about-split-reveal'));
    if (!items.length) return;

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.25 }
    );

    items.forEach((el) => observer.observe(el));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = Array.from(document.querySelectorAll('.video-showcase'));
    if (!roots.length) return;

    const wire = (root) => {
      const btn = root.querySelector('[data-video-showcase]');
      const modal = root.querySelector('[data-video-showcase-modal]');
      const overlay = root.querySelector('[data-video-showcase-overlay]');
      const closeBtn = root.querySelector('[data-video-showcase-close]');
      const iframe = root.querySelector('.video-showcase__iframe');
      const fileWrap = root.querySelector('.video-showcase__file-video');
      const fileVideoEl = fileWrap ? fileWrap.querySelector('video') : null;

      if (!btn || !modal || !overlay || !closeBtn || !iframe) return;

    const getEmbedUrl = (url) => {
      const u = String(url || '').trim();
      if (!u) return '';

      let match = null;

      if (u.includes('youtube') || u.includes('youtu.be')) {
        // Common YouTube patterns
        match =
          u.match(/(?:v=|\/)([0-9A-Za-z_-]{11})(?:\?|&|\/|$)/) ||
          u.match(/youtu\.be\/([0-9A-Za-z_-]{11})/) ||
          u.match(/shorts\/([0-9A-Za-z_-]{11})/);

        if (match && match[1]) {
          // Use muted autoplay for maximum browser compatibility; user can unmute.
          const origin = typeof window !== 'undefined' && window.location ? window.location.origin : '';
          const originParam = origin ? `&origin=${encodeURIComponent(origin)}` : '';
          return `https://www.youtube-nocookie.com/embed/${match[1]}?autoplay=1&mute=1&playsinline=1&rel=0${originParam}`;
        }
      }

      if (u.includes('vimeo')) {
        match = u.match(/vimeo\.com\/(?:video\/)?([0-9]+)/);
        if (match && match[1]) {
          return `https://player.vimeo.com/video/${match[1]}?autoplay=1`;
        }
      }

      // Fallback: hope it's an embeddable URL already
      return u;
    };

    const dialog = modal.querySelector('.video-showcase__modal-dialog');
    const openLink = modal.querySelector('[data-video-showcase-open-link]');
    const openLinkWrap = modal.querySelector('[data-video-showcase-open-link-wrap]');

    const openModal = () => {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';

      if (dialog) dialog.classList.remove('is-file-video');

      const rawVideoUrl = (btn.dataset.videoUrl || '').trim();
      const fileVideoUrl = (btn.dataset.fileVideoUrl || '').trim();
      const fileVideoMime = (btn.dataset.fileVideoMime || '').trim();
      const hasFileVideo = String(btn.dataset.hasFileVideo || '').trim() === 'true';

      // Always reset both players on open (editor can live-update settings).
      iframe.src = '';
      if (fileVideoEl) {
        try {
          fileVideoEl.pause();
          fileVideoEl.currentTime = 0;
        } catch (_) {}
      }

      const normalizeUrl = (value) => {
        const v = String(value || '').trim();
        if (!v) return '';
        // Shopify often returns protocol-relative URLs like //cdn.shopify.com/...
        if (v.startsWith('//')) return `https:${v}`;
        return v;
      };

      const isNetworkUrl = (value) => /^(https?:)?\/\//i.test(String(value || '').trim());

      const normalizedFileVideoUrl = normalizeUrl(fileVideoUrl);
      const normalizedRawVideoUrl = normalizeUrl(rawVideoUrl);

      const embedUrl = getEmbedUrl(normalizedRawVideoUrl);

      // Prefer URL embeds when provided (they're the most reliable across browsers).
      if (embedUrl) {
        if (dialog) dialog.classList.remove('is-file-video');
        if (fileWrap) fileWrap.setAttribute('aria-hidden', 'true');
        // Set src on next frame so the modal is in the DOM/layout first.
        window.requestAnimationFrame(() => {
          iframe.src = embedUrl;
        });
        if (openLink && openLinkWrap) {
          openLink.href = normalizedRawVideoUrl || embedUrl;
          openLinkWrap.hidden = false;
        }
        return;
      }

      // Otherwise fall back to the uploaded file (Shopify-hosted video).
      // Use Shopify's `video_tag` output so HLS/mp4 variants work consistently.
      if (hasFileVideo && fileVideoEl) {
        if (dialog) dialog.classList.add('is-file-video');
        if (fileWrap) fileWrap.setAttribute('aria-hidden', 'false');
        if (openLink && openLinkWrap) openLinkWrap.hidden = true;

        // Best-effort: if the merchant has an MP4 URL surfaced, set it as src to speed up playback.
        // If it's HLS (.m3u8), native playback will fail on Chrome, so we avoid forcing it.
        if (isNetworkUrl(normalizedFileVideoUrl) && !/\.m3u8(\?|#|$)/i.test(normalizedFileVideoUrl)) {
          try {
            fileVideoEl.src = normalizedFileVideoUrl;
            if (fileVideoMime) fileVideoEl.setAttribute('type', fileVideoMime);
          } catch (_) {}
        }

        try {
          fileVideoEl.muted = true;
          fileVideoEl.playsInline = true;
          fileVideoEl.load();
          const playPromise = fileVideoEl.play();
          if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
        } catch (_) {}

        // If playback doesn't actually start rendering (common with HLS-only outputs),
        // don't leave a black box — just close over to the raw URL if it's directly embeddable.
        // (We already tried embedUrl above; this is for cases where getEmbedUrl couldn't parse
        // but the value is still a usable network URL.)
        if (isNetworkUrl(normalizedRawVideoUrl)) {
          window.setTimeout(() => {
            if (!modal.classList.contains('is-open')) return;
            try {
              const hasFrames = fileVideoEl.readyState >= 2;
              const advanced = fileVideoEl.currentTime > 0;
              if (!hasFrames && !advanced) {
                if (dialog) dialog.classList.remove('is-file-video');
                if (fileWrap) fileWrap.setAttribute('aria-hidden', 'true');
                iframe.src = normalizedRawVideoUrl;
                if (openLink && openLinkWrap) {
                  openLink.href = normalizedRawVideoUrl;
                  openLinkWrap.hidden = false;
                }
              }
            } catch (_) {}
          }, 900);
        }
        return;
      }

      if (isNetworkUrl(rawVideoUrl)) {
        window.requestAnimationFrame(() => {
          iframe.src = normalizedRawVideoUrl;
        });
        if (openLink && openLinkWrap) {
          openLink.href = normalizedRawVideoUrl;
          openLinkWrap.hidden = false;
        }
      } else {
        iframe.src = '';
        if (openLinkWrap) openLinkWrap.hidden = true;
      }
    };

    const closeModal = () => {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';

      // Stop playback
      iframe.src = '';
      if (openLinkWrap) openLinkWrap.hidden = true;
      if (fileWrap) fileWrap.setAttribute('aria-hidden', 'true');
      if (fileVideoEl) {
        try {
          fileVideoEl.pause();
          fileVideoEl.currentTime = 0;
          fileVideoEl.removeAttribute('src');
          fileVideoEl.load();
        } catch (_) {}
      }
      if (dialog) dialog.classList.remove('is-file-video');
    };

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openModal();
    });

    overlay.addEventListener('click', () => closeModal());
    closeBtn.addEventListener('click', () => closeModal());

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });
    };

    roots.forEach(wire);
  })();

  } catch(e) { console.error(e); }
})();
})();
